import { useQuery } from '@tanstack/react-query';

import { myDashboardApi } from '@/services';

export const myDashboardKeys = {
  all: ['my-dashboard'] as const,
};

export function useMyDashboardQuery() {
  return useQuery({ queryKey: myDashboardKeys.all, queryFn: () => myDashboardApi.get(), refetchInterval: 120_000 });
}
